export function csvToJson(csv: string) {
    const lines = csv
        .split('\n')
        .map(line => line.trim())
        .filter(i => !!i); // skip empty lines;
    const keys = lines[0].split(',').map(i => i.trim());
    return lines.slice(1).map(line =>
        line
            .split(',')
            // skip spaces
            .map(i => i.trim())
            .reduce((acc, cur, i) => {
                const toAdd = {};
                toAdd[keys[i]] = cur;
                return { ...acc, ...toAdd };
            }, {})
    );
}
